import React from "react";

import { Upload, UploadContainer, Spinner } from "@vwfs-bronson/bronson-react";

import { Output } from "../../Text";
import { getIn } from "formik";
import { DocumentUploadItem } from "./DocumentUploadItem";
import * as Api from "./Api";
import { UploadItemState } from "../Polyfill";
import { removeStoredDocument } from '../../services/api/loadDocuments';

async function handleFileAsync(file) {
  const result = {
    name: file.name,
    size: file.size,
    type: file.type,
  };

  try {
    result.bytes = await Api.readAsync(file);
  } catch (e) {
    console.error("File processing failed", e);
  }

  return result;
}

function DocumentUploadFieldArray(props) {

  const { id, push, remove, form, name, transactionId, maxFiles } = props;
  const files = getIn(form.values, name) || [];

  const validFiles = files.filter(f => f.state === UploadItemState.SUCCESS);
  const disableUpload =
    maxFiles !== undefined && validFiles.length >= maxFiles;
  const [isLoading, setIsLoading] = React.useState(false);

  return (
    <UploadContainer
      upload={
        <Upload
          id={id}
          multiple
          disabled={disableUpload || isLoading}
          disabledText={Output.resolve("pages.heyCar.documentUpload.disabledText")}
          buttonText={Output.resolve(
            "pages.applicationForm.panels.documentUpload.placeholder"
          )}
          onChange={(event) => {
            setIsLoading(true);
            const target = event.target
            Array.from(event.target.files)
              .map(handleFileAsync)
              .forEach((file) => {
                file.then((f) => {
                  target.value = ''
                  return push(f)});
              });
          }}
        ></Upload>
      }
    >
      <>
        {isLoading && <Spinner fullPage/>}
        {files
          .map((file, index) => ({ file, index }))
          .reverse()
          .map(({ file, index }) => {
            const fieldName = `${name}[${index}]`;

            return (
              <DocumentUploadItem
                key={fieldName}
                name={fieldName}
                rootName={name}
                file={file}
                handleDelete={async () => {
                  try {
                    setIsLoading(true);
                    await removeStoredDocument(transactionId, file.id);
                    setIsLoading(false);
                    remove(index);
                  } catch (error) {
                    setIsLoading(false);
                  }
                }}
                transactionId={transactionId}
                form={form}
                setisUploading={(e)=>{setIsLoading(e)}}
                maxFiles={maxFiles}
              />
            );
          })}
      </>
    </UploadContainer>
  );
}

export { DocumentUploadFieldArray };
